import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./global.scss"; // 导入 PrimeFlex 全局样式
import "bootstrap-icons/font/bootstrap-icons.css";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/md-light-indigo/theme.css";
import { CodeLanguageProvider } from "./contexts/LanguageContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <PrimeReactProvider>
      <CodeLanguageProvider>
        <App />
      </CodeLanguageProvider>
    </PrimeReactProvider>
  </React.StrictMode>
);

reportWebVitals();
